const PREFILL_KEY = 'takamatsu_visit_prefill_v1';
const VISIT_URL = './visit.html';

function saveVisitDatePrefill(dateValue) {
	try {
		sessionStorage.setItem(PREFILL_KEY, JSON.stringify({ visit_date_value: dateValue }));
	} catch {
		// sessionStorage 不可時は遷移のみ
	}
}

function updateArrowState(scrollEl, prevBtn, nextBtn) {
	if (!(scrollEl instanceof HTMLElement)) return;

	const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
	const left = scrollEl.scrollLeft;

	if (prevBtn instanceof HTMLButtonElement) {
		prevBtn.disabled = left <= 1;
	}
	if (nextBtn instanceof HTMLButtonElement) {
		nextBtn.disabled = left >= maxScroll - 1;
	}
}

function getScrollStep(scrollEl) {
	const card = scrollEl.querySelector('.visit__dateCard');
	if (!(card instanceof HTMLElement)) return 318;

	const styles = getComputedStyle(scrollEl.querySelector('.visit__dateGrid') || scrollEl);
	const gap = Number.parseFloat(styles.columnGap || styles.gap || '2') || 2;
	return (card.offsetWidth + gap) * 5;
}

export function initBukkenDetailVisitSchedule() {
	const root = document.querySelector('[data-bukken-detail-visit-schedule]');
	if (!(root instanceof HTMLElement)) return;

	const scrollEl = root.querySelector('[data-bukken-detail-visit-scroll]');
	const prevBtn = root.querySelector('.bukkenDetail__visitScheduleArrow--prev');
	const nextBtn = root.querySelector('.bukkenDetail__visitScheduleArrow--next');

	if (scrollEl instanceof HTMLElement) {
		const onScroll = () => {
			if (prevBtn instanceof HTMLButtonElement && nextBtn instanceof HTMLButtonElement) {
				updateArrowState(scrollEl, prevBtn, nextBtn);
			}
		};

		onScroll();
		scrollEl.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);

		if (prevBtn instanceof HTMLButtonElement) {
			prevBtn.addEventListener('click', () => {
				scrollEl.scrollBy({ left: -getScrollStep(scrollEl), behavior: 'smooth' });
			});
		}
		if (nextBtn instanceof HTMLButtonElement) {
			nextBtn.addEventListener('click', () => {
				scrollEl.scrollBy({ left: getScrollStep(scrollEl), behavior: 'smooth' });
			});
		}
	}

	root.addEventListener('click', (event) => {
		const target = event.target;
		if (!(target instanceof HTMLElement)) return;

		const dateButton = target.closest('.visit__dateCard[data-date-value]');
		if (!(dateButton instanceof HTMLButtonElement)) return;

		const dateValue = dateButton.getAttribute('data-date-value') || '';
		if (!dateValue) return;

		saveVisitDatePrefill(dateValue);
		window.location.href = VISIT_URL;
	});
}
